'use strict';

/**
 * @fileOverview Cookie 工具包
 * @author ZD @zd.com
 * @version 0.0.1
 */

const Cookie = (() => {
    return {

        /**
         * @description 保存 Cookie 项
         * @param { String } key
         * @param { String } value
         * @param { Number } iDay
         * @example setCookie('account', 'admin', 300000);
         */
        /** */
        set: (key, value, iDay) => {
            var oDate = new Date();
            oDate.setDate(oDate.getDate() + iDay);
            document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + oDate;
        },
        /**
         * @description 获取 Cookie 项
         * @param { String } key
         */
        get: key => {
            var arr = document.cookie.split('; ');
            var i = 0;
            for (i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');

                if (arr2[0] === key) {
                    var getC = decodeURIComponent(arr2[1]);
                    return getC;
                }
            }
            return '';
        },
        /**
         * @description 删除 Cookie 项
         * @param { String } key
         */
        remove: key => {
            Cookie.set(key, '1', -1);
        }

    }
})();

if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = Cookie;
}